import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import Contacto from '../views/Contacto.vue'
import Reserva from '../views/Reserva.vue'
import Promocion from '../views/Promocion.vue'
import Beneficio from '../views/Beneficio.vue'
import QuinesSomos from '../views/QuinesSomos.vue'
import Flota from '../views/Flota.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/contacto',
    name: 'Contacto',   
    component: Contacto
  },
  {
    path: '/reserva',
    name: 'Reserva',   
    component: Reserva
  },
  {
    path: '/promociones',
    name: 'Promocion',   
    component: Promocion
  },
  {
    path: '/about_us',
    name: 'QuinesSomos',   
    component: QuinesSomos
  },
  {
    path: '/beneficios',
    name: 'Beneficio',   
    component: Beneficio
  },
  {
    path: '/flota',
    name: 'flota',   
    component: Flota
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL ?? window.location.origin+window.location.pathname,
  routes,

})

export default router
